import NewApi from "../api/new";

const CREATING_NEW = "CREATING_NEW",
    CREATING_NEW_SUCCESS = "CREATING_NEW_SUCCESS",
    CREATING_NEW_ERROR = "CREATING_NEW_ERROR",
    UPDATING_NEW = "UPDATING_NEW",
    UPDATING_NEW_SUCCESS = "UPDATING_NEW_SUCCESS",
    UPDATING_NEW_ERROR = "UPDATING_NEW_ERROR",
    DELETING_NEW = "DELETING_NEW",
    DELETING_NEW_SUCCESS = "DELETING_NEW_SUCCESS",
    DELETING_NEW_ERROR = "DELETING_NEW_ERROR",
    FETCHING_NEWS = "FETCHING_NEWS",
    FETCHING_NEWS_SUCCESS = "FETCHING_NEWS_SUCCESS",
    FETCHING_NEWS_ERROR = "FETCHING_NEWS_ERROR",
    FETCHING_NEW = "FETCHING_NEW",
    FETCHING_NEW_SUCCESS = "FETCHING_NEW_SUCCESS",
    FETCHING_NEW_ERROR = "FETCHING_NEW_ERROR";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        error: null,
        entities: [],
        selectedEntity: null
    },
    getters: {
        isLoading(state) {
            return state.isLoading;
        },
        hasError(state) {
            return state.error !== null;
        },
        error(state) {
            return state.error;
        },
        hasEntities(state) {
            return state.entities.length > 0;
        },
        entities(state) {
            return state.entities;
        },
        entity(state) {
            return state.selectedEntity;
        }
    },
    mutations: {
        [CREATING_NEW](state) {
            state.isLoading = true;
            state.error = null;
        },
        [CREATING_NEW_SUCCESS](state, entity) {
            state.isLoading = false;
            state.error = null;
            state.entities.unshift(entity);
        },
        [CREATING_NEW_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
            state.entities = [];
        },
        [UPDATING_NEW](state) {
            state.isLoading = true;
            state.error = null;
        },
        [UPDATING_NEW_SUCCESS](state) {
            state.isLoading = false;
            state.error = null;
        },
        [UPDATING_NEW_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
            state.entities = [];
        },
        [DELETING_NEW](state) {
            state.isLoading = true;
            state.error = null;
        },
        [DELETING_NEW_SUCCESS](state) {
            state.isLoading = false;
            state.error = null;
        },
        [DELETING_NEW_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
            state.entities = [];
        },
        [FETCHING_NEWS](state) {
            state.isLoading = true;
            state.error = null;
            state.entities = [];
        },
        [FETCHING_NEWS_SUCCESS](state, entities) {
            state.isLoading = false;
            state.error = null;
            state.entities = entities;
        },
        [FETCHING_NEWS_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
            state.entities = [];
        },
        [FETCHING_NEW](state) {
            state.isLoading = true;
            state.error = null;
            state.selectedEntity = null;
        },
        [FETCHING_NEW_SUCCESS](state, entity) {
            state.selectedEntity = entity;
            state.error = null;
            state.isLoading = false;
        },
        [FETCHING_NEW_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
            state.selectedEntity = null;
        }
    },
    actions: {
        async findAll({ commit }, ctx) {
            commit(FETCHING_NEWS);
            try {
                let response = await NewApi.findAll(ctx);
                commit(FETCHING_NEWS_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(FETCHING_NEWS_ERROR, error);
                return null;
            }
        },
        async find({ commit }, id) {
            commit(FETCHING_NEW);
            try {
                let response = await NewApi.find(id);
                commit(FETCHING_NEW_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(FETCHING_NEW_ERROR, error);
                return null;
            }
        },
        async create({ commit }, noticia) {
            commit(CREATING_NEW);
            try {
                let response = await NewApi.create(noticia);
                commit(CREATING_NEW_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(CREATING_NEW_ERROR, error);
                return null;
            }
        },
        async update({ commit }, params) {
            commit(UPDATING_NEW);
            try {
                let response = await NewApi.update(params);
                commit(UPDATING_NEW_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(UPDATING_NEW_ERROR, error);
                return null;
            }
        },
        async delete({ commit }, noticia) {
            commit(DELETING_NEW);
            try {
                let response = await NewApi.delete(noticia);
                commit(DELETING_NEW_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(DELETING_NEW_ERROR, error);
                return null;
            }
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/new.js